


















import { Vue, Component } from 'vue-property-decorator';
import { ROUTE_PATH } from '../../constant';

@Component
export default class MemberPaySuccess extends Vue {
  handlePayAgain() {
    this.$router.push({
      name: ROUTE_PATH.checkout,
      query: { ...this.$route.query }
    });
  }

  get orderInfo() {
    try {
      return JSON.parse(this.$route.query.orderInfo as string);
    } catch (e) {
      return {};
    }
  }

  handleToOrder() {
    window.location.replace(decodeURIComponent(this.orderInfo.orderUrl));
  }
}
